import React, { useState, useMemo } from "react";
import { sanitizedText } from "./utils/util";
import { Box, Stack, Text } from "native-base";
import { TouchableOpacity } from "react-native";
import UrlPreview from "./UrlPreview";

const PostText = ({ item, preferencesLang = "undefined" }) => {
  const [more, setMore] = useState(false);

  const htmlPostbgImg = useMemo(() => {
    if (!item?.text) return false;
    return /background-image\s*:\s*(?!\s*(none|unset)\b)[^;]+/i.test(item.text);
  }, [item?.text]);

  if (!item?.text) return <></>; // early return after hook

  const getBaseLang = (lang: any) => lang?.split("-")[0] || "";
  const isTranslated = item?.isTranslateText ?? false;
  let text = item.text;

  // Apply translation if available
  if (isTranslated && Array.isArray(item?.trans) && item.trans.length > 0) {
    const userLang = getBaseLang(preferencesLang);
    const matchedTranslation = item.trans.find(
      (x: any) => getBaseLang(x?.lang) === userLang,
    );
    text = matchedTranslation?.text || text;
  }

  const extracted = sanitizedText(text);
  const postText = extracted?.outputString;

  const words = postText ? postText.trim().split(/\s+/) : [];
  const wordCount = words.length;
  const truncatedText = wordCount > 70 ? words.slice(0, 66).join(" ") : "";

  // HTML post
  if (item.ptype === "H") {
    if (htmlPostbgImg) {
      text = text.replace(/<div([^>]*)style="([^"]*)"/, (match, p1, p2) => {
        if (!/height\s*:/.test(p2)) {
          if (
            !/background\s*:\s*(none|unset)/i.test(p2) &&
            !/background-image\s*:\s*(?!\s*(none|unset)\b)[^;]+/i.test(p2)
          ) {
            return `<div${p1} style="${p2}; height: 480px"`;
          }
        }
        return match;
      });
    }

    let divWidth = "100%";
    let divHeight = "auto";

    text = text.replace(/<figure[^>]*>(.*?)<\/figure>/g, "$1");

    // Extract width & height from the <div> inline style
    const divStyleMatch = text.match(
      /<div[^>]*style="[^"]*width\s*:\s*(\d+)px;[^"]*height\s*:\s*(\d+)px;?[^"]*"/i,
    );

    if (divStyleMatch) {
      divWidth = `${divStyleMatch[1]}px`;
      divHeight = `${divStyleMatch[2]}px`;
    }

    return (
      <div
        className="htmlPost"
        title="post"
        style={{
          width: htmlPostbgImg ? divWidth : "100%",
          minWidth: htmlPostbgImg ? divWidth : "100%",
          //margin: htmlPostbgImg ? "0 auto" : undefined,
          outline: "none", // remove focus outline
          userSelect: "text", // allow text selection
          cursor: "default", // optional: normal cursor instead of text caret
        }}
        contentEditable={htmlPostbgImg}
        suppressContentEditableWarning={true} // React warning suppress
        onInput={(e) => e.preventDefault()} // prevent editing
        onKeyDown={(e) => e.preventDefault()} // prevent typing
        onPaste={(e) => e.preventDefault()} // prevent pasting
        onFocus={(e) => (e.target as HTMLElement).blur()} // prevent caret focus
        dangerouslySetInnerHTML={{ __html: text }}
      />
    );
  }

  // Normal text post
  return (
    <Stack justifyContent="center" width="100%">
      <Text>
        {!more && wordCount > 70 ? `${truncatedText}... ` : postText}
        {wordCount > 70 && (
          <TouchableOpacity onPress={() => setMore(!more)}>
            <Text color="#32AE78">{more ? " less" : " more"}</Text>
          </TouchableOpacity>
        )}
      </Text>

      {extracted?.urls?.length > 0 &&
        extracted.urls.map((url, i) => (
          <Box key={i}>
            <UrlPreview url={url} />
          </Box>
        ))}
    </Stack>
  );
};

export default PostText;
